import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faChevronLeft, faUser, faMapMarkerAlt, faVectorSquare, faReceipt, faHandsHelping} 
  from '@fortawesome/free-solid-svg-icons'
import { FavIconSvg } from '../Decorators/Favorite';

export default function StaticLeftNav (props) {
  return (
    <div className="left-nav-pane">
      <img src="/tehama_logo_100p.png" className="nav-logo" onClick={() => {window.location.href='/';}} alt="Tehama Logo"></img>
      <span className='nav-margin title-vert-spacer'>
        <FontAwesomeIcon icon={faChevronLeft} color="white" className="fa-2x"/>
      </span>
      <span className="nav-back nav-margin vertical-spacer" onClick={() => window.location.href='/'}>
        Back to Site List</span>
      
      <ul className="list-group vertical-spacer" key="list-group">
        {listItem (props, "/account", ()=>faIcon(faVectorSquare), "Account")}
        {listItem (props, "/billing", ()=>faIcon(faReceipt), "Billing")}
        {listItem (props, "/sites", ()=>faIcon(faMapMarkerAlt), "Sites")}
        {listItem (props, "/grants", ()=>faIcon(faHandsHelping), "Grants")}
        {listItem (props, "/favorites", ()=>FavIconSvg({stroke: 'white', width: 22, height:22}), "Favorites")}
        {listItem(props, '/user/edit', ()=>faIcon(faUser), 'Users')}
      </ul>
    </div>
  )
}
function listItem(props, path, icon, label) {
  const selected = props.history.location.pathname
  const active = selected?.localeCompare(path) === 0
  const background = active ? "nav-color-active" : "nav-color";
  const foreground = active ? "active-li" : "inactive-li";
   return (
    <li className={'list-group-item d-flex align-items-center ' + background} 
      style={{cursor:'pointer'}} onClick={() => props.history.push(path)}>
      {icon()}&nbsp; <span className={foreground}>{label}</span>
    </li>
  )
}
function faIcon(icon) {
  return <FontAwesomeIcon icon={icon}/>
}
